import { all, call } from 'redux-saga/effects';
import { sagas as changeAutoRenew } from './changeAutoRenewModule';
import { sagas as details } from './detailsModule';
import { sagas as renew } from './renewModule';

export default function* sslCertificateSaga() {
	yield all([call(changeAutoRenew), call(details), call(renew)]);
}
